import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modal: {
    clientModal: false,
    surveyModal: false,
    userModal: false,
    lookupModal: false,
    editSurvey: false,
  },
};

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openClientModal: (state) => {
      state.modal.clientModal = true;
    },
    closeClientModal: (state) => {
      state.modal.clientModal = false;
    },
    openSurveyModal: (state) => {
      state.modal.surveyModal = true;
    },
    closeSurveyModal: (state) => {
      state.modal.surveyModal = false;
    },
    openUserModal: (state) => {
      state.modal.userModal = true;
    },
    closeUserModal: (state) => {
      state.modal.userModal = false;
    },
    openEditSurveyModal: (state) => {
      state.modal.editSurvey = true;
    },
    closeEditSurveyModal: (state) => {
      state.modal.editSurvey = false;
    },
    closeAll: (state) => {
      state.modal = initialState.modal;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  openClientModal,
  openSurveyModal,
  openUserModal,
  closeClientModal,
  closeSurveyModal,
  closeUserModal,
  openEditSurveyModal,
  closeEditSurveyModal,
  closeAll,
} = modalSlice.actions;
export const modalSelector = (state) => state.modal;

export default modalSlice.reducer;
